//import './App.css';
import React, { useState } from 'react';
import './cdanim.css';
import fotocdm from './cdm.jpg';
import { Navbar, Nav, Card, CardGroup, Form, Button } from 'react-bootstrap';
import { Cpu, CodeSquare, ShieldLock, Cast, BadgeVrFill, EyeFill, HddStackFill, FileEarmarkCodeFill, EmojiSmile, EnvelopeFill, Facebook, Twitter, Instagram, Linkedin, Github } from 'react-bootstrap-icons';
import { initializeApp } from "firebase/app";
import { getDatabase, ref, push } from "firebase/database";

import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  const firebaseConfig = {
    apiKey: "AIzaSyCB7-xI2_Zj_p0UAHs7FRYx4Ia0CUIAjXk",
    authDomain: "cdanim.firebaseapp.com",
    databaseURL: "https://cdanim-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "cdanim",
    storageBucket: "cdanim.appspot.com",
    messagingSenderId: "680495001871",
    appId: "1:680495001871:web:614fb0c1647ff3c8edce7a",
    measurementId: "G-N3VDGFNSNM"
  };
  const app = initializeApp(firebaseConfig);
  const db = getDatabase(app);
  const [validated, setValidated] = useState(false);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [hideForm, setHideForm] = useState("");
  const [afterInputForm, setAfterInputForm] = useState("d-none");
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    if (form.checkValidity() !== false) {
      setHideForm("d-none");
      setAfterInputForm("text-center mb-5");
      push(ref(db, "contactForm/"), {
        email: `${email}`,
        message: `${message}`
      });
    }
    setValidated(true);
  };
  return (
    <div className="App">
      <Navbar className="py-3" bg="dark" variant="dark" fixed="top" expand="sm">
        <Navbar.Brand className="ps-4" href="#home">Christian Dani M</Navbar.Brand>
        <Navbar.Toggle className="me-4" aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link className="px-4" href="#about">About Me</Nav.Link>
            <Nav.Link className="px-4" href="#portfolio">Portfolio</Nav.Link>
            <Nav.Link className="px-4" href="#contact">Contact Me</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <div className="vh-100 d-flex justify-content-center align-items-center bg-dark text-white" id="home">
        <div className="flex-column">
          <img src={fotocdm} className="rounded-circle" alt="cdm" id="cdmimg" />
          <h1 className ="text-center pt-4">Hi, I am Dani</h1>
          <h6 className ="text-center pt-3">Hai, Saya Dani</h6>
          <h6 className ="text-center">こんにちわ、私はダニです</h6>
        </div>
      </div>
      <div className="d-flex bg-dark anchordst" id="about"></div>
      <div className="d-flex bg-secondary text-light justify-content-center py-4">
        <h2>In a nutshell, I am a ...</h2>
      </div>
      <div className="d-flex bg-light spacer"></div>
      <div className="d-flex bg-light text-dark justify-content-center align-items-center pt-3"></div>
      <CardGroup className="mx-3 mt-3">
        <Card className="mx-3 mb-4 text-center">
          <Card.Header className="card-header-about py-4">
            <Cpu className="display-3 mb-3" />
            <h3 className="mb-3">System Administrator</h3>
            <h6 className="font-italic">I do lots of sysadmin jobs</h6>
          </Card.Header>
          <Card.Body className="card-body-about py-4 px-4">
            <Card.Text className="text-left">
              Server installation, virtualization, containerization, networking administration, monitoring performance, backup management, and many more.
            </Card.Text>
          </Card.Body>
        </Card>
        <Card className="mx-3 mb-4 text-center">
          <Card.Header className="card-header-about py-4">
            <CodeSquare className="display-3 mb-3" />
            <h3 className="mb-3">Fullstack Developer</h3>
            <h6 className="font-italic">I make apps to make my sysadmin job easier</h6>
          </Card.Header>
          <Card.Body className="card-body-about py-4 px-4">
            <Card.Text className="text-left">
              HTML, CSS, Sass, Twig, Javascript, Bootstrap, Jquery, React, PHP, Drupal, and more still to learn.
            </Card.Text>
          </Card.Body>
        </Card>
        <Card className="mx-3 mb-4 text-center">
          <Card.Header className="card-header-about py-4">
            <ShieldLock className="display-3 mb-3" />
            <h3 className="mb-3">Cybersecurity Engineer</h3>
            <h6 className="font-italic">I secure my servers</h6>
          </Card.Header>
          <Card.Body className="card-body-about py-4 px-4">
            <Card.Text className="text-left">
              Crafting SELINUX rules, managing firewall, changing default port, auditing security yearly, updating software, testing exploit and vulnerables, etc.
            </Card.Text>
          </Card.Body>
        </Card>
      </CardGroup>
      <div className="d-flex bg-light anchordst" id="portfolio"></div>
      <div className="d-flex bg-secondary text-light justify-content-center py-4">
        <h2>My journey so far ...</h2>
      </div>
      <div className="d-flex justify-content-center align-items-center bg-dark pt-3">
        <div className="d-flex flex-wrap justify-content-center align-items-center bg-dark timeline">
          <div className="bg-light line-timeline-y"></div>
          <div className="bg-warning rounded-circle">
            <h3 className="m-0 pt-1 pb-2 px-2"><Cast /></h3>
          </div>
          <div className="bg-light line-timeline-y"></div>
        </div>
        <div className="d-flex justify-content-center align-items-center bg-warning line-timeline-x">
        </div>
        <div className="d-flex justify-content-center align-items-center bg-dark card-flex-portfolio">
          <Card className="card-portfolio text-center my-3">
            <Card.Header className="py-4">
              <h4>Implemented Remote Desktop Solution</h4>
              <small>Using <a className="text-decoration-none" href="https://wiki.x2go.org/doku.php">X2Go</a> and <a className="text-decoration-none" href="https://www.cipherdyne.org/fwknop/">fwknop</a>, <a className="text-decoration-none" href="https://www.nomachine.com/">NoMachine</a> at <a className="text-decoration-none" href="https://www.konimex.com/">Konimex</a> (2016-2017)</small>
            </Card.Header>
            <Card.Body className="py-4 px-4">
              <Card.Text>Cut the time needed to solve user's problem from hours to minutes</Card.Text>
            </Card.Body>
          </Card>
        </div>
      </div>
      <div className="d-flex justify-content-center align-items-center bg-dark">
        <div className="d-flex flex-wrap justify-content-center align-items-center bg-dark timeline">
          <div className="bg-light line-timeline-y"></div>
          <div className="bg-warning rounded-circle">
            <h3 className="m-0 pt-1 pb-2 px-2"><BadgeVrFill /></h3>
          </div>
          <div className="bg-light line-timeline-y"></div>
        </div>
        <div className="d-flex justify-content-center align-items-center bg-warning line-timeline-x">
        </div>
        <div className="d-flex justify-content-center align-items-center bg-dark card-flex-portfolio">
          <Card className="card-portfolio text-center my-3">
            <Card.Header className="py-4">
              <h4>Virtualized Baremetal Servers</h4>
              <small>Experimenting with <a className="text-decoration-none" href="https://www.proxmox.com/en/">Proxmox</a>, <a className="text-decoration-none" href="https://www.vmware.com/">VMWare</a>, <a className="text-decoration-none" href="https://www.virtualbox.org/">VirtualBox</a>, and <a className="text-decoration-none" href="https://xenserver.org/">Xen Server</a> at <a className="text-decoration-none" href="https://www.konimex.com/">Konimex</a> (2019)</small>
            </Card.Header>
            <Card.Body className="py-4 px-4">
              <Card.Text>Taking benefits of virtual system without losing performance</Card.Text>
            </Card.Body>
          </Card>
        </div>
      </div>
      <div className="d-flex justify-content-center align-items-center bg-dark">
        <div className="d-flex flex-wrap justify-content-center align-items-center bg-dark timeline">
          <div className="bg-light line-timeline-y"></div>
          <div className="bg-warning rounded-circle">
            <h3 className="m-0 pt-1 pb-2 px-2"><EyeFill /></h3>
          </div>
          <div className="bg-light line-timeline-y"></div>
        </div>
        <div className="d-flex justify-content-center align-items-center bg-warning line-timeline-x">
        </div>
        <div className="d-flex justify-content-center align-items-center bg-dark card-flex-portfolio">
          <Card className="card-portfolio text-center my-3">
            <Card.Header className="py-4">
              <h4>Implemented Monitoring Systems</h4>
              <small>Using <a className="text-decoration-none" href="https://pandorafms.com/">Pandora FMS</a>, and <a className="text-decoration-none" href="https://www.zabbix.com/">Zabbix</a> at <a className="text-decoration-none" href="https://www.konimex.com/">Konimex</a> (2019-2020)</small>
            </Card.Header>
            <Card.Body className="py-4 px-4">
              <Card.Text>Servers, Switches, Access Points, even Workstations with real-time alert via <a className="text-decoration-none" href="https://telegram.org/">Telegram</a></Card.Text>
            </Card.Body>
          </Card>
        </div>
      </div>
      <div className="d-flex justify-content-center align-items-center bg-dark">
        <div className="d-flex flex-wrap justify-content-center align-items-center bg-dark timeline">
          <div className="bg-light line-timeline-y"></div>
          <div className="bg-warning rounded-circle">
            <h3 className="m-0 pt-1 pb-2 px-2"><HddStackFill /></h3>
          </div>
          <div className="bg-light line-timeline-y"></div>
        </div>
        <div className="d-flex justify-content-center align-items-center bg-warning line-timeline-x">
        </div>
        <div className="d-flex justify-content-center align-items-center bg-dark card-flex-portfolio">
          <Card className="card-portfolio text-center my-3">
            <Card.Header className="py-4">
              <h4>Enhanced Backup to Next Level</h4>
              <small>Using <a className="text-decoration-none" href="https://restic.net/">Restic</a>, created <a className="text-decoration-none" href="https://github.com/chrizneko/backupcdm">BackupCDM</a> at <a className="text-decoration-none" href="https://www.konimex.com/">Konimex</a> (2020-now)</small>
            </Card.Header>
            <Card.Body className="py-4 px-4">
              <Card.Text>Improved backup & restore time, reduced storage needed; even with more backups stored</Card.Text>
            </Card.Body>
          </Card>
        </div>
      </div>
      <div className="d-flex justify-content-center align-items-center bg-dark">
        <div className="d-flex flex-wrap justify-content-center align-items-center bg-dark timeline">
          <div className="bg-light line-timeline-y"></div>
          <div className="bg-warning rounded-circle">
            <h3 className="m-0 pt-1 pb-2 px-2"><FileEarmarkCodeFill /></h3>
          </div>
          <div className="bg-light line-timeline-y"></div>
        </div>
        <div className="d-flex justify-content-center align-items-center bg-warning line-timeline-x">
        </div>
        <div className="d-flex justify-content-center align-items-center bg-dark card-flex-portfolio">
          <Card className="card-portfolio text-center my-3">
            <Card.Header className="py-4">
              <h4>Created <a className="text-decoration-none" href="https://nekodlaupr.web.app/">Nekodlau Project</a></h4>
              <small>(2021-now)</small>
            </Card.Header>
            <Card.Body>
              <Card.Text>I am helping people to make websites as a side job</Card.Text>
            </Card.Body>
          </Card>
        </div>
      </div>
      <div className="d-flex bg-dark text-light justify-content-center py-4">
        <h5 className="text-center px-3">And of course, never stop learning new things! <EmojiSmile /> (born-now) </h5>
      </div>
      <div className="vh-100 d-flex justify-content-center align-items-center bg-black text-white" id="contact">
        <div className="flex-column">
          <h2 className="pb-5 text-center">Contact Me</h2>
          <Form noValidate validated={validated} onSubmit={handleSubmit} className={hideForm}>
            <Form.Group className="mb-3 mx-5" controlId="InputEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control required type="email" placeholder="name@example.com" value={email} onChange={(e) => setEmail(e.target.value)} />
              <Form.Control.Feedback type="invalid">Please provide a valid email address</Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3 mx-5" controlId="InputMessage">
              <Form.Label>Message</Form.Label>
              <Form.Control required as="textarea" rows={3} placeholder="You can contact me here!" value={message} onChange={(e) => setMessage(e.target.value)} />
              <Form.Control.Feedback type="invalid">This textbox is required</Form.Control.Feedback>
            </Form.Group>
            <p className="text-center mb-5 mt-4"><Button variant="primary" type="submit">Submit</Button></p>
          </Form>
          <h4 className={afterInputForm}>Your message has been sent!</h4>
          <h4 className="text-center">
            <a href="mailto:chrizneko93@gmail.com"><EnvelopeFill className="me-2" /></a>
            <a href="https://www.facebook.com/chriz.neko"><Facebook className="mx-2" /></a>
            <a href="https://twitter.com/chrizneko"><Twitter className="mx-2" /></a>
            <a href="https://instagram.com/chrizneko"><Instagram className="mx-2" /></a>
            <a href="https://www.linkedin.com/in/chriz-neko-1b5238200/"><Linkedin className="mx-2" /></a>
            <a href="https://github.com/chrizneko"><Github className="ms-2" /></a>
          </h4>
          <p className="pt-5 text-center">© 2021 Copyright: <a href="https://nekodlaupr.web.app" className="text-decoration-none">Nekodlau Project</a></p>
          <p className="ps-4">Made with Love, <a className="text-decoration-none" href="https://reactjs.org/">React</a>, <a className="text-decoration-none" href="https://react-bootstrap.github.io/">React Bootstrap</a>, <a className="text-decoration-none" href="https://www.npmjs.com/package/react-bootstrap-icons">React Bootstrap Icons</a>, and <a className="text-decoration-none" href="https://firebase.google.com/">Firebase</a></p>
        </div>
      </div>
    </div>
  );
}

export default App;
